import { useEffect, useState } from "react";

// React DOM
import { Link, useNavigate, useParams } from "react-router-dom";

// Axios
import Axios from "../../api/axios";

// Scroll animation - AOS
import Aos from "aos";
import "aos/dist/aos.css";

// Icons & Backgrounds
import LinkedInBlackLogo from "../../images/icons/LinkedInBlack.png";

// CSS styling
import "../../styles/about.css";
import "../../styles/previousButton.css";

// Components
import ContainerText from "../../components/Container";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Seo, { organizationRef } from "../../components/Seo";

// Helpers
import { absoluteUrl, plainText } from "../../helpers/seo";

const TeamDetail = () => {
  const navigate = useNavigate();
  const [teamMember, setTeamMember] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const { id } = useParams();

  const fetchMember = async () => {
    const response = await Axios.get(`/teamMember/${id}`).catch((err) => {
      console.log("Err: ", err);
    });
    if (response && response.data && response.data.name) {
      setTeamMember(response.data);
      setNotFound(false);
    } else {
      setNotFound(true);
    }
    setLoaded(true);
  };

  useEffect(() => {
    setLoaded(false);
    fetchMember();
    Aos.init({ duration: 1000 });
  }, [id]);

  return (
    <div>
      {loaded && notFound ? (
        <Seo title="Team member not found" noindex />
      ) : null}
      {loaded && !notFound ? (
        <Seo
          title={
            teamMember.jobTitle &&
            `${teamMember.name} - ${teamMember.jobTitle}`.length <= 50
              ? `${teamMember.name} - ${teamMember.jobTitle}`
              : teamMember.name
          }
          description={
            plainText(teamMember.description, 155) ||
            `${teamMember.name}${
              teamMember.jobTitle ? `, ${teamMember.jobTitle}` : ""
            } at the Institute for Sustainability and Agility (ISA).`
          }
          path={`/about/teammembers/${id}`}
          image={teamMember.picture}
          imageAlt={teamMember.name}
          type="profile"
          breadcrumbs={[
            { name: "About", path: "/about/company" },
            { name: "Team Members", path: "/about/teammembers" },
            { name: teamMember.name, path: `/about/teammembers/${id}` },
          ]}
          jsonLd={{
            "@type": "Person",
            "@id": `${absoluteUrl(`/about/teammembers/${id}`)}#person`,
            name: teamMember.name,
            jobTitle: teamMember.jobTitle || undefined,
            image: teamMember.picture || undefined,
            url: absoluteUrl(`/about/teammembers/${id}`),
            worksFor: organizationRef,
            sameAs: teamMember.linkedIn ? [teamMember.linkedIn] : undefined,
          }}
        />
      ) : null}
      <Header />
      <ContainerText
        props={
          <div id="theFounder">
            <div className="founderProfileContainer">
              <div
                className="previousButton"
                onClick={() => navigate("/about/teammembers")}
              >
                <span className="expertiseArrowRight">
                  <i className="fas fa-angle-left" />
                </span>
                <Link
                  to="/about/teammembers"
                  onClick={(e) => e.stopPropagation()}
                >
                  Back to previous page
                </Link>
              </div>
              <div className="founderProfileBio">
                <div className="founderProfileBioPicture">
                  <img src={teamMember.picture} alt={teamMember.name} />
                </div>
                <div className="founderProfileBioText">
                  <div className="founderProfileBioTextName title">
                    <h1 className="seoH1">{teamMember.name}</h1>
                  </div>
                  <div className="founderProfileBioTextTitle paragraf">
                    <p>{teamMember.jobTitle}</p>
                  </div>
                  <div className="founderProfileBioTextLinkedIn">
                    <a
                      href={teamMember.linkedIn}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={LinkedInBlackLogo} alt="LinkedIn" />
                    </a>
                    <a
                      href={teamMember.linkedIn}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="aboutFounder">
              <div className="aboutFounderMainContainer">
                <div className="founderAbout">
                  <div className="aboutUsTitle headerDescription">
                    <p>About</p>
                    <hr />
                  </div>
                  <div className="aboutText paragraf">
                    <p>{teamMember.description}</p>
                  </div>
                </div>
                <div
                  className="founderPublishedWorks"
                  style={{ display: "none" }}
                >
                  <div className="aboutUsTitle">
                    <p>Published Works</p>
                    <hr />
                  </div>
                  <div
                    className="publishedWorksList"
                    style={{ display: "none" }}
                  >
                    <ul>
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit{" "}
                        <a href="">click here to download</a>
                      </li>
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit{" "}
                        <a href="">click here to download</a>
                      </li>
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit{" "}
                        <a href="">click here to download</a>
                      </li>
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit{" "}
                        <a href="">click here to download</a>
                      </li>
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit{" "}
                        <a href="">click here to download</a>
                      </li>
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit{" "}
                        <a href="">click here to download</a>
                      </li>
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit{" "}
                        <a href="">click here to download</a>
                      </li>
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit{" "}
                        <a href="">click here to download</a>
                      </li>
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit{" "}
                        <a href="">click here to download</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="aboutFounderSpecialisation"
                style={{ display: "none" }}
              >
                <div className="specialisationTitle">
                  <p>Specialisation</p>
                </div>
                <div className="specialisationList">
                  <ul>
                    <li>Corporate Social Responsibility (CSR)</li>
                    <li>Sustainability</li>
                    <li>Environmental, Social and Governance (ESG)</li>
                    <li>Inclusive Finance</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        }
      />
      <Footer />
    </div>
  );
};

export default TeamDetail;
